import TextFilter from "./text-filter";

export default function BoreholeNameFilter({boreholeName, setBoreholeName, applyFilters} : any) {    
    return (
        <TextFilter label="Borehole Name" text={boreholeName} setText={setBoreholeName} applyFilters={applyFilters}/>
    )
}